import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import './App.css'
import theme from './utils/theme'
import { ThemeProvider } from 'styled-components'
import ScrollToTop from './components/Helpers/ScrollToTop'
import { routes } from './routes'

// Renders route based on layout
const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
)

class App extends Component {
  render () {
    return (
      <Router>
        <ScrollToTop>
          <ThemeProvider theme={theme}>
            <Switch>
              {routes.map((route, index) => (
                <AppRoute
                  key={index}
                  exact={route.exact}
                  layout={route.layout}
                  path={route.path}
                  component={route.component}
                />
              ))}
              {/* <Redirect to='/error' /> */}
            </Switch>
          </ThemeProvider>
        </ScrollToTop>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js